import * as React from 'react';
import { FormCard } from '@qbe/ads-blocks-forms';
import { useContent, useContentContext } from '@qbe/dfc-content';

const InternalErrorMessage = () => {
  const { getTextContent } = useContent({ context: useContentContext() });

  // Localized content constants
  const pageTitle = getTextContent('internalErrorMessage.title');
  const description = getTextContent('internalErrorMessage.description');

  return <FormCard variant="pageTitle" title={pageTitle} description={description} />;
};

export default InternalErrorMessage;
